import { Button } from "semantic-ui-react";
import { fetchCurrentCompany } from "../../../actions/company.actions";
import { useDispatch } from "react-redux";
import { advisorAPI } from "../../../apis/AdvisorsAPI";
import { useState } from "react";
import { responseError } from "../../../helpers";
import PasswordConfirmationModal from "../../modal/PasswordModal";



const SwitchWideSharing = ({ company, isButton = true }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [openModalConfirm, setOpenModalConfirm] = useState(false);

  const isFirmwideClientAutoSharingEnabled = company?.enterpriseSettings?.isFirmwideClientAutoSharingEnabled

  const sendValidationToken = (val) => {
    activeDisabled(val)
  }

  const activeDisabled = async (token) => {
    setLoading(true);
    try {
      let confirmation = true
      if(!isFirmwideClientAutoSharingEnabled){
        // eslint-disable-next-line no-restricted-globals
        confirmation = confirm(`This action could take quite a while.`)
      }
      if(confirmation){
        await advisorAPI.put(`/companies/settings/preferences`, {
          "isFirmwideClientAutoSharingEnabled": !isFirmwideClientAutoSharingEnabled
        },{
          params:{
            companyId: company._id
          },
          headers: {'Validation-Token': token}
        });
        await dispatch(fetchCurrentCompany(company._id));
      }
    } catch (error) {
      responseError(error)
    }
    setLoading(false)
  }

  return (
    <>
      {isButton ? (
        <Button color={isFirmwideClientAutoSharingEnabled ? "green" : "red"} onClick={() => setOpenModalConfirm(true)} loading={loading}>
          Wide Sharing: {isFirmwideClientAutoSharingEnabled ? "Active" : "Disabled"}
        </Button>
      ) : (
        <div color={isFirmwideClientAutoSharingEnabled ? "green" : "red"} onClick={() => setOpenModalConfirm(true)} loading={loading} >
          {loading ? (
            <>
              🟠 Changing...
            </>
          ) : (
            <>
              {isFirmwideClientAutoSharingEnabled ? "🟢 Wide Sharing: Active" : "🔴 Wide Sharing: Disabled"}
            </>
          )}
        </div>
      )}
      <PasswordConfirmationModal
        setValidationToken={(val) => sendValidationToken(val)}
        modalState={openModalConfirm}
        setModalState={(val) => setOpenModalConfirm(val)}
      />
    </>
  );
};

export default SwitchWideSharing;
